import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Typography from '../../../components/Typography';
import COLORS from '../../../util/constants/colors';
import './voiceRecording.scss';

const VoiceRecording = ({ callId, isOutbound }) => {
  const [callRecording, setCallRecording] = useState(null);
  const [callRecordingContentType, setCallRecordingContentType] = useState('audio/wav');
  const requestIdRef = useRef(0);

  const getCallRecording = (recordingCallId, outbound) => {
    const url = outbound
      ? `/api/v1/outbound_call_logs/${recordingCallId}/audio`
      : `/api/v1/call_logs/${recordingCallId}/audio`;

    return axios({
      method: 'GET',
      url,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
    });
  };

  useEffect(() => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    let cancelled = false;

    setCallRecording(null);
    setCallRecordingContentType('audio/wav');
    if (callId) {
      getCallRecording(callId, isOutbound).then((response) => {
        if (cancelled || requestIdRef.current !== requestId) return;

        setCallRecording(response.data.recording);
        setCallRecordingContentType(response.data.content_type || 'audio/wav');
      });
    }

    return () => {
      cancelled = true;
    };
  }, [callId, isOutbound]);

  // Create audio source directly from base64 data
  const audioSource = callRecording
    ? `data:${callRecordingContentType};base64,${callRecording}`
    : null;

  const renderAudio = () => {
    if (audioSource) {
      return (
        <audio src={audioSource} controls type={callRecordingContentType}>
          <track kind="captions" />
        </audio>
      );
    }
    return (
      <div className="voice-recording-placeholder">
        <audio controls controlsList="noplaybackrate" type="audio/wav" style={{ opacity: 0.5 }}>
          <track kind="captions" />
        </audio>
        <Typography style={{ fontStyle: 'italic' }} variant="text" size="small" color={COLORS.TEXT_SECONDARY_LITE}>
          *No recording available
        </Typography>
      </div>
    );
  };

  return (
    <div className="voice-recording">
      {renderAudio()}
      <div className="divider" />
    </div>
  );
};

VoiceRecording.defaultProps = {
  callId: null,
  isOutbound: false,
};

VoiceRecording.propTypes = {
  callId: PropTypes.string,
  isOutbound: PropTypes.bool,
};

export default VoiceRecording;
